import { render, staticRenderFns } from "./PerformanceTargetNew.vue?vue&type=template&id=566292dc"
import script from "./PerformanceTargetNew.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports